import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const CustomerProfileSidebar = React.lazy(
  () => import("./customer-profile.sidebar")
);

const CustomerProfile: iModalProps<
  typeof CustomerProfileSidebar,
  { customerId?: string }
> = {
  name: "customer-profile-sidebar",
  component: GenerateModalWithSuspense(CustomerProfileSidebar),
};

export default CustomerProfile;
